import { render, staticRenderFns } from "./SignUpForms.vue?vue&type=template&id=7004b3cf&"
import script from "./SignUpForms.vue?vue&type=script&lang=js&"
export * from "./SignUpForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports